window.onload = function() {
  var images = document.getElementsByClassName("contact-strip__cone");

  if (images.length > 0) {
    var image = images[0];

    setInterval(function() {
      image.classList.add("shake-me");

      setTimeout(function() {
        image.classList.remove("shake-me");
      }, 1000);
    }, 1500);
  }
};
